import type { QueryClient } from '@tanstack/react-query';
import {
  createRootRouteWithContext,
  type ErrorComponentProps,
  Outlet,
  useRouter,
} from '@tanstack/react-router';
import { AppLockScreen } from '~/components/app-lock';
import { PrimaryButton, RingLogo, ToastHost } from '~/components/ui';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
  errorComponent: RootError,
  notFoundComponent: NotFound,
});

function Root() {
  return (
    <div className="app-frame">
      <Outlet />
      <ToastHost />
      <AppLockScreen />
    </div>
  );
}

function RootError({ error }: ErrorComponentProps) {
  const router = useRouter();
  return (
    <div className="app-frame">
      <div className="flex flex-1 flex-col items-center justify-center gap-4 px-8 text-center">
        <RingLogo size={54} />
        <div className="font-display text-[22px] font-bold">Something went wrong</div>
        <div className="text-[14px] text-slate-500">
          {(error instanceof Error && error.message) || 'Please try again.'}
        </div>
        <PrimaryButton className="mt-2 w-auto px-7" onClick={() => void router.invalidate()}>
          Try again
        </PrimaryButton>
      </div>
    </div>
  );
}

function NotFound() {
  const router = useRouter();
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 px-8 text-center">
      <RingLogo size={54} />
      <div className="font-display text-[22px] font-bold">Page not found</div>
      <PrimaryButton className="mt-2 w-auto px-7" onClick={() => void router.navigate({ to: '/' })}>
        Go home
      </PrimaryButton>
    </div>
  );
}
